/**
 * Erreurs typées pour distinguer les échecs API côté client.
 * Utilisées par TanStack Query (retry policy) et par le code applicatif.
 */

export class ApiUnauthorizedError extends Error {
  readonly status = 401;
  readonly name = 'ApiUnauthorizedError';
  constructor(message = 'Non autorisé', public readonly originalBody?: unknown) {
    super(message);
  }
}

export class ApiForbiddenError extends Error {
  readonly status = 403;
  readonly name = 'ApiForbiddenError';
  constructor(message = 'Accès refusé', public readonly originalBody?: unknown) {
    super(message);
  }
}

export class ApiServerError extends Error {
  readonly name = 'ApiServerError';
  constructor(
    public readonly status: number,
    message = 'Erreur serveur',
    public readonly originalBody?: unknown
  ) {
    super(message);
  }
}

export class ApiNetworkError extends Error {
  readonly name = 'ApiNetworkError';
  constructor(message = 'Erreur réseau', public readonly originalError?: unknown) {
    super(message);
  }
}

/**
 * Fabrique la bonne erreur typée à partir d'une Response fetch non-OK.
 */
export async function errorFromResponse(res: Response): Promise<Error> {
  const body = await res.json().catch(() => ({ message: res.statusText }));
  const message =
    (typeof body === 'object' && body && 'message' in body && typeof body.message === 'string'
      ? body.message
      : res.statusText) || `API Error ${res.status}`;

  if (res.status === 401) return new ApiUnauthorizedError(message, body);
  if (res.status === 403) return new ApiForbiddenError(message, body);
  if (res.status >= 500) return new ApiServerError(res.status, message, body);
  return new ApiServerError(res.status, message, body);
}
